import { use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { useTranslation } from 'react-i18next';
import { EBulkActionFeatures } from '../table_base/EBulkActionFeatures';
import { WSButtonFeaturesAllowAllNewUsersTemplate } from './buttons/WSButtonFeaturesAllowAllNewUsersTemplate';
import { WSButtonFeaturesAllowAllUser } from './buttons/WSButtonFeaturesAllowAllUser';
import { WSButtonFeaturesDenyAllNewUsersTemplate } from './buttons/WSButtonFeaturesDenyAllNewUsersTemplate';
import { WSButtonFeaturesDenyAllUser } from './buttons/WSButtonFeaturesDenyAllUser';
import { WSFeaturesNewUsersTemplateCheckbox } from './WSFeaturesNewUsersTemplateCheckbox';
import { WSFeaturesCheckbox } from './WSFeaturesUserCheckbox';

interface Props {
  feature: string;
  index: number;
  category: string;
}

export function WSFeaturesTableRow({ feature, index, category }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { workspace_current, all_workspaces_users_map } = use_slice_workspace(['workspace_current', 'all_workspaces_users_map']);
  const { user_id } = use_slice_user(['user_id']);

  function render_cells() {
    let users_from_this_workspace = all_workspaces_users_map.get_or_assert(workspace_current._id, { context: 'users_from_this_workspace' });

    let users = Array.from(users_from_this_workspace.values()).filter(item => item.user_id !== user_id);
    users.sort(DTO__workspace_user.sort_by_updated_at_newest_first);

    let users_cells = users.map(item => {
      let out = <></>;

      if (feature === EBulkActionFeatures.ALLOW) {
        out = <WSButtonFeaturesAllowAllUser user={item} />;
      } else if (feature === EBulkActionFeatures.DENY) {
        out = <WSButtonFeaturesDenyAllUser user={item} />;
      } else {
        out = <WSFeaturesCheckbox user={item} feature={feature} />;
      }

      return (
        <span key={`${item._id}${feature}`} className={`${md('min-w-[40px] text-[12px]', 'w-[80px]')}  flex items-center justify-center`}>
          {out}
        </span>
      );
    });

    return users_cells;
  }

  function render_cells_with_template() {
    let out = <></>;

    if (feature === EBulkActionFeatures.ALLOW) {
      out = <WSButtonFeaturesAllowAllNewUsersTemplate />;
    } else if (feature === EBulkActionFeatures.DENY) {
      out = <WSButtonFeaturesDenyAllNewUsersTemplate />;
    } else {
      out = <WSFeaturesNewUsersTemplateCheckbox feature={feature} />;
    }

    return (
      <>
        <span
          className={`${md('min-w-[40px] text-[12px]', 'w-[80px] h-[50px]')} border-r border-dashed border-component-item flex items-center justify-center`}
        >
          {out}
        </span>

        {render_cells()}
      </>
    );
  }

  return (
    <div className={`${md('px-2 justify-start gap-2', 'px-5 justify-start')} w-full min-h-[50px] flex flex-row items-center `}>
      <span className={`${md('min-w-[130px] text-[9px]', 'w-[400px]')}  text-left`}>
        {t(((i18n_page_settings_workspace.tabs.features_access.table as any)[category] as any).features[feature])}
      </span>

      {render_cells_with_template()}
    </div>
  );
}
